<section class="py-5 bg-light">
  <div class="container">

    <!-- Section Header -->
    <div class="text-center mb-5">
      <span class="badge rounded-pill bg-warning-subtle text-warning px-3 py-2 mb-3">
        BEE Scorecard Elements
      </span>

      <h2 class="fw-bold mt-3">
        Track Every Element of Your <span class="text-warning">BEE Score</span>
      </h2>

      <p class="text-muted mt-2">
        Comprehensive dashboards for each BEE element with targets, metrics,
        compliance checklists, and action items.
      </p>
    </div>

    <!-- Grid -->
    <div id="bee_scorecard_grid" class="row g-4"></div>

    <!-- Card Template -->
    <template id="bee_scorecard_template">
      <div class="col-md-6 col-lg-4">
        <div class="h-100 bg-white border rounded-4 shadow-sm p-4 position-relative">

          <!-- Top Accent -->
          <div class="scorecard_accent position-absolute top-0 start-0 w-100 rounded-top"></div>

          <!-- Points Badge -->
          <span class="scorecard_points badge rounded-pill border text-dark position-absolute top-0 end-0 m-3">
          </span>

          <!-- Icon -->
          <div class="scorecard_icon mb-3 fs-3"></div>

          <!-- Content -->
          <h5 class="scorecard_title fw-semibold mb-2"></h5>
          <p class="scorecard_description text-muted mb-0 text-sm"></p>

        </div>
      </div>
    </template>

  </div>
</section>
